export default __webpack_public_path__ + "static/media/fake-objects-2@1x.522c1733.png";